import React from "react";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import styled from "styled-components";

const StyledTextField = styled(TextField)({
  "& input[type=number]": {
    "-moz-appearance": "textfield",
    "-webkit-appearance": "none",
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
      margin: 0,
    },
  },
});

const CustomTextField = ({ label, required, ...rest }) => {
  return (
    <Box>
      <Typography
        variant="customLable"
        color="common.inputCustomLable"
        marginBottom={1}
      >
        {label}
        {required && <span style={{ color: "#C50F1F" }}>*</span>}
      </Typography>
      <StyledTextField
        {...rest}
        variant="outlined"
        fullWidth
        InputLabelProps={{
          style: { color: "#444444" },
        }}
      />
    </Box>
  );
};

export default CustomTextField;
